module.exports = __webpack_public_path__ + "static/img/作品42.2eb1e87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品42.png
// module id = 6/v8
// module chunks = 1